import { render, staticRenderFns } from "./BgBrush.vue?vue&type=template&id=5c084bdc&"
import script from "./BgBrush.vue?vue&type=script&lang=js&"
export * from "./BgBrush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports